import {
  useWatchlistNameDialogController,
  type WatchlistNameDialogMode,
} from "./WatchlistNameDialog.controller";
import { WatchlistNameDialogPresentation } from "./WatchlistNameDialog.pres";

export type { WatchlistNameDialogMode };

export interface WatchlistNameDialogProps {
  mode: WatchlistNameDialogMode;
  initialName: string;
  /** Server-side failure (duplicate name, …) — field errors come from the form. */
  error: string | null;
  isSubmitting: boolean;
  onClose: () => void;
  onSubmit: (name: string) => void;
}

/**
 * Mounted only while open, so a fresh draft comes from remounting — the
 * connector always passes `open={true}` and the parent removes this subtree
 * when mode becomes null.
 */
export const WatchlistNameDialog = ({
  mode,
  initialName,
  error,
  isSubmitting,
  onClose,
  onSubmit,
}: WatchlistNameDialogProps) => {
  const {
    name,
    validationError,
    onNameChange,
    onSubmit: handleSubmit,
  } = useWatchlistNameDialogController({ mode, initialName, onSubmit });

  return (
    <WatchlistNameDialogPresentation
      open={true}
      mode={mode}
      name={name}
      error={error ?? validationError}
      isSubmitting={isSubmitting}
      onOpenChange={(next) => {
        if (!next) {
          onClose();
        }
      }}
      onNameChange={onNameChange}
      onSubmit={handleSubmit}
    />
  );
};
